import React from 'react';
import { Dialog, DialogContent, DialogClose } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';

const MembershipDialog = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent noCloseBtn className="w-[320px] p-[30px]">
        <div className="flex flex-col items-start  ">
          <div className="text-gr-900 Title3S18">모니터링 상품 개수가 초과됐어요</div>
          <div className=" text-gr-700 Body5M14">최대 10개의 상품까지 모니터링 할 수 있어요.</div>
          <div className="flex w-full gap-2">
            <DialogClose asChild>
              <Button variant="muted" className="mt-[20px] h-[44px] flex-1">
                닫기
              </Button>
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MembershipDialog;
